import { ArrowPathIcon } from '@heroicons/react/20/solid'
import { IconButton } from './Button'
import {
  useInvalidateWalletTokens,
  useWalletTokens,
} from 'hooks/useWalletTokens'

const RefetchBalancesButton = () => {
  const { isFetching: fetchingBalances } = useWalletTokens()
  const invalidateWalletTokens = useInvalidateWalletTokens()
  return (
    <IconButton onClick={() => invalidateWalletTokens()} hideBg>
      <ArrowPathIcon
        className={`size-4 text-th-fgd-2 hover:text-th-fgd-1 ${
          fetchingBalances ? 'animate-spin' : ''
        }`}
      />
    </IconButton>
  )
}

export default RefetchBalancesButton
